import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'

import { useState } from 'react'

import { OrderModel } from '@/types/model/Order'
import { CustomerModel } from '@/types/model/Customer'

import { useOrderMutations } from './useOrderMutations'

export const useCreateOrder = () => {
  const navigate = useNavigate()
  const { createOrder, loading } = useOrderMutations()

  const [selectedCustomer, setSelectedCustomer] = useState<CustomerModel.Customer | null>(null)
  const [customerInfo, setCustomerInfo] = useState({ name: '', phone: '' })
  const [deliveryInfo, setDeliveryInfo] = useState({ name: '', phone: '', address: '' })
  const [items, setItems] = useState<
    Array<{ product_variation_id: string; quantity: number; name: string; price: number }>
  >([])
  const [paymentMethod, setPaymentMethod] = useState<'cod' | 'online'>('cod')
  const [paymentOption, setPaymentOption] = useState<'cash' | 'ssl_commerz'>('cash')
  const [discount, setDiscount] = useState(0)
  const [deliveryLocationTypeId, setDeliveryLocationTypeId] = useState('')

  const handleCreate = async () => {
    if (items.length === 0) {
      toast.error('Please add at least one item')
      return
    }
    if (!customerInfo.name || !customerInfo.phone) {
      toast.error('Customer Name and Phone are required')
      return
    }
    if (!deliveryLocationTypeId) {
      toast.error('Delivery Location Type ID is required')
      return
    }

    const payload: OrderModel.CreateOrderPayload = {
      ...(selectedCustomer ? { customer_id: selectedCustomer._id } : {}),
      customer_info: customerInfo,
      delivery_info: deliveryInfo.name ? deliveryInfo : undefined,
      items: items.map((i) => ({
        product_variation_id: i.product_variation_id,
        quantity: i.quantity,
      })),
      discount,
      payment_method: paymentMethod,
      payment_option: paymentOption,
      delivery_location_type_id: deliveryLocationTypeId,
    }

    const result = await createOrder(payload)
    if (result) {
      navigate('/orders')
    }
  }

  const addItem = (item: {
    product_variation_id: string
    quantity: number
    name: string
    price: number
  }) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.product_variation_id === item.product_variation_id)
      if (existing) {
        return prev.map((i) =>
          i.product_variation_id === item.product_variation_id
            ? { ...i, quantity: i.quantity + item.quantity }
            : i
        )
      }
      return [...prev, item]
    })
  }

  const removeItem = (id: string) => {
    setItems((prev) => prev.filter((i) => i.product_variation_id !== id))
  }

  const updateQuantity = (id: string, quantity: number) => {
    if (quantity < 1) return
    setItems((prev) => prev.map((i) => (i.product_variation_id === id ? { ...i, quantity } : i)))
  }

  return {
    loading,
    selectedCustomer,
    setSelectedCustomer,
    customerInfo,
    setCustomerInfo,
    deliveryInfo,
    setDeliveryInfo,
    items,
    addItem,
    removeItem,
    updateQuantity,
    paymentMethod,
    setPaymentMethod,
    paymentOption,
    setPaymentOption,
    discount,
    setDiscount,
    deliveryLocationTypeId,
    setDeliveryLocationTypeId,
    handleCreate,
    navigate,
  }
}
